import { useRef, useEffect, useCallback, PropsWithChildren, FC, useState } from 'react'
import { Spin } from 'antd'
import { Column } from '@antv/g2plot';
import Card from '@/pages/Tbqy/components/components/Card'
import * as api from '@/api/tbyqy'
import styles from '@/pages/Tbqy/style.module.less'

const data = [];

for(let i=0; i<12; i++) {
  data.push({
    "label": i+ 1 + "月",
    "type": "今年",
    "value": 0
  })
  data.push({
    "label": i+ 1 + "月",
    "type": "去年",
    "value": 0
  })
}

const tabsOptions = [
  {
    label: '投标', 
    value: 'BMTB',
    api: api.getTbsjtjAbmTb
  }, {
    label: '中标', 
    value: 'BMZB',
    api: api.getTbsjtjAbmZb
  }
]

type PropType = FC<PropsWithChildren<{
  updateTime: string
}>>

const Component: PropType = ({updateTime}) => {
  const [loading, setLoading] = useState(false)
  const containerRef = useRef()
  const [rand, setRand] = useState([])
  const globalRef = useRef({
    activeTab: tabsOptions[0].value,
    column: null as Column
  })

  useEffect(() => {
    globalRef.current.column = new Column(containerRef.current, {
      data,
      xField: 'label',
      yField: 'value',
      seriesField: 'type',
      isGroup: true,
      legend: {
        position: 'bottom',
      },
      columnStyle: {
      },
      xAxis: {
        label: {
          rotate: 0.4,
          style: {
            textAlign: 'start',
          }
        }
      }
    });

    globalRef.current.column.render();
  }, [])

  // 获取图表数据
  const getColumnData = useCallback(async () => {
    const tabOption = tabsOptions.find(t => t.value === globalRef.current.activeTab)
    if(!tabOption) {
      return
    }
    const res = await tabOption.api(true)
    if(res.success) {
      setRand(res.data.BMZBrate || res.data.jnZBrate || [])
      globalRef.current.column.changeData((res.data.list || []).reduce((c, n) => {
        c.push({
          label: n.SQRBM,
          value: n.jnZBnum || n.jnTBnum || 0,
          type: '今年'
        })
        c.push({
          label: n.SQRBM,
          value: n.qnZBnum || n.qnTBnum || 0,
          type: '去年'
        })
        return c
      }, []))
    }
  }, [])

  // 获取接口数据
  const getList = useCallback(async () => {
    setLoading(true)
    Promise.all([getColumnData()]).finally(() => {
      setLoading(false)
    })
  }, [getColumnData])

  // 变更类型
  const handleTabChange = useCallback((value) => {
    globalRef.current.activeTab = value
    getList()
  }, [getList])

  useEffect(() => {
    getList()
  }, [updateTime, getList])

  return (
    <Spin spinning={loading}>
      <Card title="投标数据统计（按部门）" tabs={tabsOptions} onTabChange={handleTabChange}>
        <div className={`flex ${styles['tb-sj']}`}>
          <div className={`${styles['tb-sj-left']} flex flex-column`}>
            <div>各所中标率排名</div>
            <div className='flex-1 h-0 overflow-auto'>
              {
                rand.map((r, idx) => (
                  <div className='flex align-center ptb-6' key={r.SQRBM}>
                    <div className={`${styles['tb-sj-left-item-circle']} ${idx < 3 ? styles.active : ''}`}>{idx + 1}</div>
                    <div className='flex-1 w-0 text-777 ml-8 mr-4 ellipsis'>{r.SQRBM}</div>
                    <div className='font-700'>{r.jnZBLv}</div>
                    {/* <div className='text-777 ml-2'>%</div> */}
                  </div>
                ))
              }
             
            </div>
          </div>
          <div className='flex-1 w-0 ml-10'>
            <div className='h-full' ref={containerRef}></div>
          </div>
        </div>
      </Card>
    </Spin>
  )
}

export default Component
